/** case.interface */

import { definitions } from '@/types/api';

/** 0-情景构建与推演,1-风险监测预警,2-应急决策支持,3-应急物资保障,4-地理信息基础管理平台,5-应急指挥调度,6-指挥决策互动 */
export const caseModuleArr = [
  '情景构建与推演',
  '风险监测预警',
  '应急决策支持',
  '应急物资保障',
  '地理信息基础管理平台',
  '应急指挥调度',
  '指挥决策互动',
];

/**
 * case
 */
export interface Case {
  /** 名称 */
  name: string;

  /** 难度 */
  difficulty: string;

  /** 案例图片 */
  img: string;

  /** 案例描述 */
  introduce: string;

  /** 注册表名称-唤醒名 */
  registryName: string;

  /** 安装包名称 */
  packageName: string;
}

/**
 * 案例类型
 */
export class CaseImpl implements Case {
  /** 名称 */
  name: string;

  /** 难度 */
  difficulty: string;

  /** 案例图片 */
  img: string;

  /** 案例描述 */
  introduce: string;

  /** 注册表名称-唤醒名 */
  registryName: string;

  /** 安装包名称 */
  packageName: string;

  /** 0-情景构建与推演,1-风险监测预警,2-应急决策支持,3-应急物资保障,4-地理信息基础管理平台,5-应急指挥调度,6-指挥决策互动 */
  caseModule?: definitions['ExperimentCaseModuleCountResponse']['caseModule'];

  constructor(name: string, difficulty: string, img: string, introduce: string, registryName: string, packageName: string) {
    this.name = name;
    this.difficulty = difficulty;
    this.img = img;
    this.introduce = introduce;
    this.registryName = registryName;
    this.packageName = packageName;
  }
}
